<template>
  <div>
    <div class="list-group">
        <div
          v-for="(section, index) in formSections"
          :key="index">
        <router-link
          v-if="section.show()"
          :class="defaultClass"
          :to="section.route">
            {{section.label}}
            <i :class="section.completed() ? checkIconClass : defaultIconClass" :style="section.completed() ? 'color: green' : ''"></i>
        </router-link>
        </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'formProgress',
  data () {
    return {
      defaultClass: 'list-group-item list-group-item-action disabled',
      checkIconClass: 'fas fa-check float-right',
      defaultIconClass: 'fas fa-arrow-down float-right',
      formSections: [
        {
          label: 'Policy details',
          route: '/makeaclaim',
          show: () => { return true },
          completed: () => {
            if (this.$store.state.claimform.claimForm.data.policy && this.$store.state.claimform.claimForm.data.policy.number != '') {
              return true
            } else {
              return false
            }
          }
        },
        {
          label: 'Your details',
          route: '/makeaclaim',
          show: () => { return true },
          completed: () => {
            if (this.$store.state.claimform.claimForm.data.claimant && this.$store.state.claimform.claimForm.data.claimant.ukResident != null) {
              return true
            } else {
              return false
            }
          }
        },
        {
          label: 'Trip details',
          route: '/makeaclaim',
          show: () => { return this.$store.state.claimform.claimForm.data.occurredAbroad == true },
          completed: () => {
            if (this.$store.state.claimform.claimForm.data.occurredAbroad && this.$store.state.claimform.claimForm.data.incident.tripCountry != '') {
              return true
            } else {
              return false
            }
          }
        },
        {
          label: 'Gadget details',
          route: '/makeaclaim',
          show: () => { return true },
          completed: () => {
            if (this.$store.state.claimform.claimForm.data.gadgets && this.$store.state.claimform.claimForm.data.gadgets.length > 0) {
              return true
            } else {
              return false
            }
          }
        },
        {
          label: 'Incident details',
          route: '/makeaclaim',
          show: () => { return true },
          completed: () => {
            if (this.$store.state.claimform.claimForm.data.incident && this.$store.state.claimform.claimForm.data.incident.dateOfIncident != '') {
              return true
            } else {
              return false
            }
          }
        },
        {
          label: 'Supporting documents',
          route: '/makeaclaim',
          show: () => { return true },
          completed: () => {
            if (this.$store.state.claimform.claimForm.data.documents && this.$store.state.claimform.claimForm.data.documents.length > 0) {
              return true
            } else {
              return false
            }
          }
        },
        {
          label: 'Review claim details',
          route: '/makeaclaim',
          show: () => { return true },
          completed: () => { return false }
        }
      ]
    }
  }
}
</script>
